export function isLoggedIn(): boolean {
    let user = localStorage.getItem('user');
    let token = localStorage.getItem('token');
    let tokenExpiration = localStorage.getItem('tokenExpiration');

    if (user && token && tokenExpiration) {
        const now = new Date().getTime();
        if (now < parseInt(tokenExpiration)) {
            return true;

        } else {
            console.log('Token expired; now=' + now + '; tokenExpiration=' + tokenExpiration);
        }
    } else {
        console.log('User is not logged in, cant find user, token or token expiration');
    }

    return false;
}

export function logOut() {
    localStorage.removeItem('user');
}

export function getLoggedInUser(): string | null {
    return localStorage.getItem('user');
}

export function setLoggedInUser(user: string, token: string, role: string) {
    localStorage.setItem('user', user);
    localStorage.setItem('token', token);
    localStorage.setItem('role', role);

    const fiveHours = 5 * 60 * 60 * 1000;
    const now = new Date().getTime();
    localStorage.setItem('tokenExpiration', (now + fiveHours).toString());
}

export function redirectToLogon() {
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    window.location.href = '/login';
}

function redirectIdNeeded() {
    if (!isLoggedIn()) {
        redirectToLogon();
    }
}

export function getTokenOrRedirect(): string {

    redirectIdNeeded();

    let token = localStorage.getItem('token');
    if (token) {
        return token;
    }

    window.location.href = '/login';
    return '';
}

export function getRoleOrRedirect(): string {
    redirectIdNeeded();

    let role = localStorage.getItem('role');
    if (role) {
        return role;
    }

    window.location.href = '/login';
    return '';
}

export function isUserAdmin() {
    return getRoleOrRedirect() === 'ADMIN';
}
